import { FlexCenterBoth } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import { useAtom } from 'jotai';
import styled, { css } from 'styled-components';
import { useEffect } from 'react';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import useIsMount from 'utils/useIsMount';
import { captainOptionsAtom } from '../filterStore';

export default function AtomRadioButton({ label, selected }) {
  const [, setCaptainOptions] = useAtom(captainOptionsAtom);
  const rudderTrack = useRudderStackTrack();
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      rudderTrack('checkbox_toggle_search', {
        value: selected,
        label,
      });
    }
  }, [selected]);

  const handleClick = () => {
    let isSelected = false;
    setCaptainOptions((prev) =>
      prev.map((option) => {
        if (option.label === label) {
          isSelected = !option.selected;
          return { ...option, selected: !selected };
        }
        return { ...option, selected: false };
      })
    );
    rudderTrack('checkbox_toggle_search', {
      value: isSelected,
      label,
    });
  };

  return (
    <CheckButton checked={selected} onClick={handleClick}>
      <Text fSize="14px" fWeight="500">
        {label}
      </Text>
    </CheckButton>
  );
}

const CheckButton = styled(FlexCenterBoth)<{ checked: boolean }>`
  border: 1px solid #dbdfe5;
  border-radius: 4px;
  cursor: pointer;
  padding: 16px;
  text-align: center;
  min-width: 50px;

  ${({ checked }) =>
    checked &&
    css`
      background: #eef3fb;
      border-color: transparent;
      color: #0751c2;
    `};
`;
